import Vue from 'vue';
import VueRouter from 'vue-router';

import BasicLayout from '../components/BasicLayout';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: BasicLayout,
    redirect: '/applyOrderCert',
    children: [
      {
        path: 'applyOrderCert',
        component: () => import('../views/ApplyOrderCert.vue'),
      },
      {
        path: 'applyCert',
        component: () => import('../views/ApplyCert.vue'),
      },
      {
        path: 'notify',
        component: () => import('../views/Notify.vue'),
      },
      {
        path: 'deniedApply',
        component: () => import('../views/DeniedApply.vue'),
      },
      {
        path: 'certDetail',
        component: () => import('../views/CertDetail.vue'),
      },
      {
        path: 'applyCertResult',
        component: () => import('../views/ApplyCertResult.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;
